import { periodRange } from './dashboardData'

export const individualPeriodOptions = [
  { value: '7d', label: 'Últimos 7 dias' },
  { value: '15d', label: 'Últimos 15 dias' },
  { value: 'month', label: 'Último mês' },
  { value: 'quarter', label: 'Trimestre' },
  { value: 'semester', label: 'Semestre' },
  { value: 'year', label: 'Ano' },
  { value: 'all', label: 'Todo período' },
] as const

export type IndividualPeriod = typeof individualPeriodOptions[number]['value']

function utcDate(value: string) {
  return new Date(`${value}T12:00:00.000Z`)
}

function iso(date: Date) {
  return date.toISOString().slice(0, 10)
}

export function individualPeriodRange(period: IndividualPeriod, anchor: string) {
  if (period === '7d' || period === '15d' || period === 'month') {
    const days = period === '7d' ? 7 : period === '15d' ? 15 : 30
    const endDate = utcDate(anchor)
    const startDate = new Date(endDate)
    startDate.setUTCDate(startDate.getUTCDate() - (days - 1))
    return {
      start: iso(startDate),
      end: iso(endDate),
      label: period === 'month' ? 'Últimos 30 dias' : `Últimos ${days} dias`,
    }
  }

  const range = periodRange(period, anchor)
  const date = utcDate(anchor)
  const year = date.getUTCFullYear()
  const label = period === 'quarter'
    ? `${Math.floor(date.getUTCMonth() / 3) + 1}º trimestre de ${year}`
    : period === 'semester'
      ? `${date.getUTCMonth() < 6 ? 1 : 2}º semestre de ${year}`
      : period === 'year'
        ? `Ano de ${year}`
        : 'Todo o período'
  return { ...range, label }
}
